module.exports = __webpack_public_path__ + "static/img/chanping2.57cde57.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img1/nxyp1/chanping2.jpg
// module id = M32K
// module chunks = 0